import { ElementStatus } from '@wix/rules-panel-ui';
import { useCallback, useMemo } from 'react';
import { BiCtaNames, BiFieldNames, BiNotificationTypes } from '../../../../../../../bi/types';
import { DisabledButtonTooltipTranslationKeySuffix } from '../../../../utils/get-disabled-button-tooltip-translation-key-suffix';
export const useBiCallbacks = _ref => {
  let {
    biLogger,
    images,
    missingCount
  } = _ref;
  const getImageData = useCallback(imageId => {
    const index = images.findIndex(img => img.id === imageId);
    return {
      image: index !== -1 ? images[index] : undefined,
      index
    };
  }, [images]);
  return useMemo(() => ({
    element: {
      onBlur: (imageId, value) => {
        const {
          index,
          image
        } = getImageData(imageId);
        biLogger.elementFieldChange({
          fieldName: BiFieldNames.AltText,
          index,
          status: (image == null ? void 0 : image.status) ?? ElementStatus.Failed,
          value
        });
      },
      onEnlargeClick: imageId => {
        const {
          index,
          image
        } = getImageData(imageId);
        biLogger.taskElementCtaClick({
          ctaName: BiCtaNames.EnlargeImage,
          index,
          status: (image == null ? void 0 : image.status) ?? ElementStatus.Failed
        });
      },
      onMinimizeClick: imageId => {
        const {
          index,
          image
        } = getImageData(imageId);
        biLogger.taskElementCtaClick({
          ctaName: BiCtaNames.MinimizeImage,
          index,
          status: (image == null ? void 0 : image.status) ?? ElementStatus.Failed
        });
      },
      onPrefixIconTooltipView: () => {
        biLogger.tooltipView({
          tooltipName: DisabledButtonTooltipTranslationKeySuffix.FAIL_TO_AI,
          tooltipOrigin: 'Alt text task'
        });
      },
      onStatusChange: imageId => {
        const {
          index,
          image
        } = getImageData(imageId);
        if (image) {
          biLogger.elementStatusChange({
            index,
            isAiGenerated: [ElementStatus.Generated, ElementStatus.GeneratedAll].includes(image.status),
            status: image.status,
            value: image.altText
          });
        }
      },
      onTooltipView: tooltipName => {
        biLogger.tooltipView({
          tooltipName: tooltipName
        });
      }
    },
    onApplyClick: () => {
      biLogger.ctaClick({
        ctaName: BiCtaNames.Apply
      });
      biLogger.taskCtaClick({
        ctaName: BiCtaNames.Apply,
        elementCount: images.length,
        failedElementCount: missingCount
      });
    },
    onBackClick: () => {
      biLogger.taskCtaClick({
        ctaName: BiCtaNames.Back,
        elementCount: images.length,
        failedElementCount: missingCount
      });
      biLogger.ctaClick({
        ctaName: BiCtaNames.Back
      });
    },
    onBulkGenerateTooltipView: tooltipName => {
      biLogger.tooltipView({
        tooltipName: tooltipName
      });
    },
    onCancelClick: () => {
      biLogger.taskCtaClick({
        ctaName: BiCtaNames.Cancel,
        elementCount: images.length,
        failedElementCount: missingCount
      });
      biLogger.ctaClick({
        ctaName: BiCtaNames.Cancel
      });
    },
    onCloseClick: () => {
      biLogger.taskCtaClick({
        ctaName: BiCtaNames.CloseTheWizard,
        elementCount: images.length,
        failedElementCount: missingCount
      });
    },
    onDecorativeToggle: (imageId, isDecorative) => {
      const {
        index,
        image
      } = getImageData(imageId);
      biLogger.elementFieldChange({
        fieldName: BiFieldNames.Checkbox,
        index,
        status: (image == null ? void 0 : image.status) ?? ElementStatus.Failed,
        value: isDecorative ? 'on' : 'off'
      });
    },
    onGenerateClick: (type, imageId) => {
      if (type === 'bulk') {
        biLogger.taskCtaClick({
          ctaName: BiCtaNames.Generate,
          elementCount: images.length,
          failedElementCount: missingCount
        });
      } else if (imageId) {
        const {
          index,
          image
        } = getImageData(imageId);
        biLogger.taskElementCtaClick({
          ctaName: BiCtaNames.Generate,
          index,
          status: (image == null ? void 0 : image.status) ?? ElementStatus.Failed
        });
      }
    },
    onImageToggle: (imageId, isOpening) => {
      if (isOpening) {
        const {
          index,
          image
        } = getImageData(imageId);
        biLogger.taskElementCtaClick({
          ctaName: BiCtaNames.Edit,
          index,
          status: (image == null ? void 0 : image.status) ?? ElementStatus.Failed
        });
      }
    },
    onWarningShown: () => {
      biLogger.notificationView({
        notificationType: BiNotificationTypes.AiCanMakeMistakes
      });
    },
    summary: {
      onRetryClick: payload => {
        biLogger.taskNotificationCtaClick({
          ctaName: BiCtaNames.TryAgain,
          notificationType: BiNotificationTypes.altTextGeneratedResultsStatus,
          payload: payload
        });
      },
      onSortClick: payload => {
        biLogger.taskNotificationCtaClick({
          ctaName: BiCtaNames.SortFirst,
          notificationType: BiNotificationTypes.altTextGeneratedResultsStatus,
          payload: payload
        });
      },
      onSummaryView: payload => {
        biLogger.taskNotificationView({
          notificationType: BiNotificationTypes.altTextGeneratedResultsStatus,
          payload: payload
        });
      },
      onTooltipView: tooltipName => {
        biLogger.tooltipView({
          tooltipName: tooltipName
        });
      }
    }
  }), [biLogger, getImageData, images.length, missingCount]);
};
//# sourceMappingURL=use-bi-callbacks.js.map